import { render, staticRenderFns } from "./PackagedProductLog.vue?vue&type=template&id=67e25e2e"
import script from "./PackagedProductLog.vue?vue&type=script&lang=js"
export * from "./PackagedProductLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports